<template>
  <v-card>
    <v-container style="max-width: 1500px">
      <v-row>
        <v-col cols="12">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Stock Reports</v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row dense>
            <v-col cols="12" md="3">
              <span style="margin-left: 16px">Reports</span><br>

              <v-btn to="/check-stock" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Check Available
                Stock</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/check-full-stock" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Check Full
                Stock (Including zero stock & -ves)</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/combined-stock" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Combined
                Stock</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/stock-by-category" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock By
                Category</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/branches-stock" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Branches
                Stock</v-btn><br />
              <!-- 
                <v-btn to="/stock/report/audit" text color="menuColor" left
                  ><v-icon left>mdi-view-list</v-icon> Full Stock Audit</v-btn
                ><br /> -->

              <v-btn  v-if="userLoaded && !AmayaVersion" to="/transfer-deliveries" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Transfers Deliveries</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/transfer-products-list" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Transfer Product List</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/stock/report/valuation" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Valuation Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/combined-stock-value" text color="menuColor" left><v-icon left>mdi-chart-line</v-icon>
                Combined
                Stock Value Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/stock/movement/analysis" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Movement Analysis</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/stock/movement/totals" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Movement Totals</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion" to="/stock-adjustment-report" text color="menuColor" left><v-icon left>mdi-view-list</v-icon> Stock
                Adjustment Report</v-btn><br />
            </v-col>

          </v-row>
        </v-col>

      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {},
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      datacollection: {},
      loader: false,
      smsRef: null,
      loading: false,
      record: {},
      callsData: [],
      search: null,
      dashData: {},
      startField: "StartDate",
      endField: "EndDate",
      trueValue: true,
      AmayaVersion: true,
      userLoaded: false,
    };
  },
  methods: {
    deleteData() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/reset-account`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show("Reset Done", "blue");
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(data) {
      this.record = { ...this.record, [data.fieldName]: data.date };
    },
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
    getUserDetails() {
      const userId = localStorage.getItem("userId");
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUserDetails();
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.cardText {
  font-weight: bold;
  font-size: 18px;
  padding: 12px;
  color: #757575;
}

.dash-btn {
  margin-top: -5px;
}
</style>